import React from "react";
import {ICommentFieldInputProps} from "../InputFields";

export function InputComment ({input}) {
    const commentProps = {
    widthMd: input.width || 12,
    content: input.config?.content
} as ICommentFieldInputProps

    return (
        <div className={`field col-${commentProps.widthMd}`} dangerouslySetInnerHTML={{__html: commentProps.content}}></div>
    )
}